var exports = {
  "V": "DiffPlaceholderSVG__g5uL_V",
};

module.exports = exports;
